import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PreviewProvider } from "@tradvera/design-system";
import "@tradvera/design-system/styles.css";
import "@tradvera/academy-domain/styles.css";
import "@tradvera/trade-domain/styles.css";
import "./portal.css";
import "./admin.css";
import "./companion/companion.css";
import { PortalApp } from "./PortalApp";
import { AuthBoundary, AuthProvider } from "./Auth";
import { AdminApp } from "./AdminApp";
import { CompanionApp } from "./companion/CompanionApp";

const adminRoute = window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/");
const companionRoute = window.location.pathname === "/companion" || window.location.pathname.startsWith("/companion/");

createRoot(document.getElementById("root")!).render(<StrictMode><AuthProvider><PreviewProvider><AuthBoundary>{adminRoute ? <AdminApp /> : companionRoute ? <CompanionApp /> : <PortalApp />}</AuthBoundary></PreviewProvider></AuthProvider></StrictMode>);
